import Guid from "_shared/guids/guid";

export default class SelectedVendorTeam {
  public static fromURLSearchParams(params: URLSearchParams): SelectedVendorTeam | undefined {
    const targetTeamIdParam = params.get("tTeamId");
    const targetTeamNameParam = params.get("tTeamName");

    if (!targetTeamIdParam) return;

    return new SelectedVendorTeam(new Guid(targetTeamIdParam), targetTeamNameParam ?? undefined);
  }

  public targetTeamId: Guid;
  public targetTeamName?: string;

  constructor(targetTeamId: Guid, targetTeamName?: string) {
    this.targetTeamId = targetTeamId;
    this.targetTeamName = targetTeamName;
  }

  public generateTargetUrl(action: "create" | "request", location: Location): URL {
    let url;
    if (action === "request") {
      url = new URL(`/proposals/request`, location.origin);
    } else {
      url = new URL(`/proposals/drafts/${action}`, location.origin);
    }
    url.searchParams.append("tTeamId", this.targetTeamId.value);
    if (this.targetTeamName) {
      url.searchParams.append("tTeamName", this.targetTeamName);
    }
    return url;
  }
}
